import { useHistory } from "react-router-dom";
import { Blueprint } from "../../../../models/Blueprints";
import useBlueprintContext from "../../context/useBlueprintContext";
import { navigateToBlueprintEditor } from "../../../../router/RouterUtils";
import EmptyStateWrapper from "../../../shared/layout/EmptyStateWrapper";
import { Dialog } from "@merge-api/merge-javascript-shared";
import { BlueprintVersionHistoryTableHead } from "./BlueprintVersionHistoryTableHead";
import { BlueprintVersionHistoryTableRows } from "./BlueprintVersionHistoryTableRows";
import { DiffModalTypeEnum, DiffModelTypeEnum } from "../../../../models/DiffModels";
import { useState } from "react";
import { viewBlueprintDiff } from "../../utils/BlueprintEditorUtils";

import DiffModal from "../../../shared/diff-view/DiffModal";

interface Props {
  isVisible: boolean;
  onHide: () => void;
}

const BlueprintVersionHistoryModal = ({ onHide, isVisible }: Props) => {
  const history = useHistory();
  const { blueprint, blueprintVersions } = useBlueprintContext();
  const [blueprintToCompare, setBlueprintToCompare] = useState<Blueprint>();
  const [isShowingDiffModal, setIsShowingDiffModal] = useState(false);
  const [isLoadingBlueprintToCompare, setIsLoadingBlueprintToCompare] = useState(false);

  const integrationID = blueprint.integration.id;

  function viewBlueprintVersion(blueprint_version_id: string) {
    navigateToBlueprintEditor(history, integrationID, blueprint_version_id);
    onHide();
  }

  return (
    <>
      <Dialog
        title="Version history"
        open={isVisible}
        onClose={onHide}
        variant="xl"
        footerButtonsHidden
      >
        <div className="overflow-y-auto -mt-5 -mx-6 -mb-6 max-h-[720px]">
          {blueprintVersions ? (
            <table className="w-full">
              <BlueprintVersionHistoryTableHead />
              <BlueprintVersionHistoryTableRows
                blueprint={blueprint}
                blueprintVersions={blueprintVersions}
                onView={viewBlueprintVersion}
                onCompare={(blueprintVersion) => {
                  viewBlueprintDiff(
                    onHide,
                    setBlueprintToCompare,
                    setIsShowingDiffModal,
                    setIsLoadingBlueprintToCompare,
                    blueprint,
                    blueprintVersion.id
                  );
                }}
              />
            </table>
          ) : (
            <EmptyStateWrapper isSpinner />
          )}
        </div>
      </Dialog>
      {isShowingDiffModal && (
        <DiffModal
          isModalOpen={isShowingDiffModal}
          setIsModalOpen={setIsShowingDiffModal}
          diffModalType={DiffModalTypeEnum.COMPARE}
          modelType={DiffModelTypeEnum.BLUEPRINT}
          isLoadingStates={isLoadingBlueprintToCompare}
          newState={blueprint}
          newStateTitle={`Blueprint version - ${blueprint.version.comment}`}
          currentState={blueprintToCompare ?? {}}
          currentStateTitle={`Blueprint version - ${blueprintToCompare?.version.comment}`}
        />
      )}
    </>
  );
};

export default BlueprintVersionHistoryModal;
